import axios from "axios";
import { ElMessageBox } from 'element-plus'

const BASE_URL = ''
const service = axios.create({
    // baseURL: "https://victor.wxc1997cheshi.top",
    baseURL: "https://zhixingweb.wxc1997cheshi.top",
    // baseURL:"http://192.168.0.108:19006",
    timeout: 5000
})
 
export default service;
